export const RESTRICTED_KRATOM_JURISDICTIONS = [
  { code: "AL", name: "Alabama" },
  { code: "AR", name: "Arkansas" },
  { code: "IN", name: "Indiana" },
  { code: "LA", name: "Louisiana" },
  { code: "VT", name: "Vermont" },
  { code: "WI", name: "Wisconsin" },
] as const;

const stateAliases = new Map<string, string>([
  ["AL", "AL"], ["ALABAMA", "AL"],
  ["AR", "AR"], ["ARKANSAS", "AR"],
  ["IN", "IN"], ["INDIANA", "IN"],
  ["LA", "LA"], ["LOUISIANA", "LA"],
  ["VT", "VT"], ["VERMONT", "VT"],
  ["WI", "WI"], ["WISCONSIN", "WI"],
  ["UT", "UT"], ["UTAH", "UT"],
]);

export const RESTRICTED_DESTINATION_MESSAGE =
  "Unfortunately, Kratown cannot ship to your location due to current state or local regulations.";

export const UTAH_GUMMY_RESTRICTED_DESTINATION_MESSAGE =
  "Unfortunately, Kratown cannot ship gummy products to Utah due to current state or local regulations.";

export type CartProductReference = {
  title?: string | null;
  productHandle?: string | null;
  sku?: string | null;
};

export function normalizeUsState(value: string | null | undefined) {
  const normalized = String(value ?? "").trim().replace(/\./g, "").replace(/\s+/g, " ").toUpperCase();
  return stateAliases.get(normalized) ?? null;
}

export function getRestrictedJurisdiction(value: string | null | undefined) {
  const code = normalizeUsState(value);
  return RESTRICTED_KRATOM_JURISDICTIONS.find((jurisdiction) => jurisdiction.code === code) ?? null;
}

export function isRestrictedKratomDestination(value: string | null | undefined) {
  return Boolean(getRestrictedJurisdiction(value));
}

export function hasGummyProduct(items: readonly CartProductReference[] | null | undefined) {
  return Boolean(
    items?.some((item) =>
      [item.title, item.productHandle, item.sku]
        .filter((value): value is string => typeof value === "string")
        .join(" ")
        .toLowerCase()
        .includes("gumm"),
    ),
  );
}

export function getCheckoutDestinationRestriction(
  value: string | null | undefined,
  items: readonly CartProductReference[] | null | undefined,
) {
  const restrictedJurisdiction = getRestrictedJurisdiction(value);
  if (restrictedJurisdiction) {
    return {
      jurisdiction: restrictedJurisdiction,
      message: RESTRICTED_DESTINATION_MESSAGE,
      scope: "all_kratom" as const,
    };
  }

  if (normalizeUsState(value) === "UT" && hasGummyProduct(items)) {
    return {
      jurisdiction: { code: "UT", name: "Utah" },
      message: UTAH_GUMMY_RESTRICTED_DESTINATION_MESSAGE,
      scope: "gummies_only" as const,
    };
  }

  return null;
}
